module.exports = __webpack_public_path__ + "img/checklist.3eab50c0.png";